import React from 'react';

import PropTypes from 'prop-types';
import {
    parse as parseQueryString,
} from 'query-string';
import { connect } from 'react-redux';

import Helmet from 'wanderu-component-helmet';
import { Redirect } from 'wanderu-component-react-router-link';
import {
    PageDialogWrapper,
} from 'wanderu-components';
import {
    userInfoSelectors,
} from 'wanderu-ducks-account';
import { localize } from 'wanderu-i18n';

import config from '../../config/baseApp.locales';
import BareSignUpContainer from './BareSignUp';

import styles from './SignUp.scss';

function SignUpContainer(props) {
    const {
        isLoggedIn,
        location,
        t,
    } = props;

    const queryParams = parseQueryString(location.search);
    const { email } = queryParams;

    if (isLoggedIn) {
        return (
            <Redirect
                href="/account/mytrips/"
                push
            />
        );
    }

    const title = t('create-an-account-title_meta');
    const description = t('create-an-account-description_meta');

    return (
        <div className={styles.page}>
            <Helmet
                description={description}
                supportedLocales={config.supportedLocales}
                title={title}
            />
            <PageDialogWrapper
                title={t('signup-for-account')}
            >
                <BareSignUpContainer email={email} />
            </PageDialogWrapper>
        </div>
    );
}

SignUpContainer.propTypes = {
    isLoggedIn: PropTypes.bool,
    location: PropTypes.object,
};

SignUpContainer.defaultProps = {
    isLoggedIn: false,
};

const mapStateToProps = (appState) => {
    return {
        isLoggedIn: userInfoSelectors.selectUserLoggedIn(appState),
    };
};

export {
    SignUpContainer,
    mapStateToProps,
};

const localizedSignUpContainer = localize(SignUpContainer, ['t'], config.namespace);
export default connect(mapStateToProps)(localizedSignUpContainer);
